var map = {
	"./degreezy/iteration.png": 8437,
	"./degreezy/mockup1.png": 1610,
	"./degreezy/mockup2.png": 2721,
	"./degreezy/mockup3.png": 2504,
	"./degreezy/mockup4.png": 2119,
	"./degreezy/outcome1.png": 8907,
	"./degreezy/outcome2.png": 5088,
	"./degreezy/prototype1_1.png": 8005,
	"./degreezy/prototype2_1.png": 6242,
	"./degreezy/prototype2_2.png": 2825,
	"./degreezy/schema.png": 2143,
	"./degreezy_cover.png": 9197,
	"./magnet/focus_1.jpg": 7193,
	"./magnet/focus_2.jpg": 8526,
	"./magnet/outcome_1.jpg": 5889,
	"./magnet/outcome_2.jpg": 8118,
	"./magnet/outcome_3.jpg": 6643,
	"./magnet/process_1.jpg": 7966,
	"./magnet_cover.jpg": 4308,
	"./nook/-----studio2.png": 853,
	"./nook/brainstorming1.jpg": 7488,
	"./nook/brainstorming2.jpg": 1215,
	"./nook/outcome1.jpg": 7003,
	"./nook/outcome2.jpg": 2348,
	"./nook/outcome3.jpg": 9225,
	"./nook/pinup.jpg": 6514,
	"./nook/prototype1.jpg": 3157,
	"./nook/prototype2.jpg": 5306,
	"./nook/prototype3.jpg": 6471,
	"./nook/studio.jpg": 1404,
	"./nook/thumbnail.jpg": 8172,
	"./nook_cover.jpg": 3781,
	"./oldisgold/----prototype1_1.png": 6881,
	"./oldisgold/----prototype2_2.png": 3957,
	"./oldisgold/----research2.png": 2479,
	"./oldisgold/----research4.png": 5625,
	"./oldisgold/----unify1_1.png": 216,
	"./oldisgold/----unify1_2.png": 5827,
	"./oldisgold/concept1_1.png": 4299,
	"./oldisgold/concept1_2.png": 3088,
	"./oldisgold/concept2_1.png": 3308,
	"./oldisgold/concept2_2.png": 3367,
	"./oldisgold/concept3_1.png": 4381,
	"./oldisgold/concept3_2.png": 3174,
	"./oldisgold/concept4.png": 4314,
	"./oldisgold/interaction1.png": 4755,
	"./oldisgold/interaction2.png": 9480,
	"./oldisgold/journey.png": 1236,
	"./oldisgold/metamorphic1.png": 3130,
	"./oldisgold/metamorphic2.png": 7793,
	"./oldisgold/mini.png": 3663,
	"./oldisgold/modern.png": 7903,
	"./oldisgold/paper1.png": 8117,
	"./oldisgold/paper2.png": 6014,
	"./oldisgold/prototype1_1.png": 8677,
	"./oldisgold/prototype1_2.png": 2926,
	"./oldisgold/prototype1_3.png": 615,
	"./oldisgold/prototype2_1.png": 1250,
	"./oldisgold/research1.png": 3728,
	"./oldisgold/research3.png": 3410,
	"./oldisgold/revision.png": 7061,
	"./oldisgold/sketch1.png": 8793,
	"./oldisgold/sketch2.png": 2210,
	"./oldisgold/survey1_1.png": 6935,
	"./oldisgold/survey1_2.png": 8460,
	"./oldisgold/survey2.png": 7232,
	"./oldisgold/unify1_1.jpg": 1800,
	"./oldisgold_cover.png": 3069,
	"./pushpin/background1.jpeg": 4214,
	"./pushpin/background2.jpeg": 6147,
	"./pushpin/emulation1.jpg": 1743,
	"./pushpin/emulation2.jpg": 8016,
	"./pushpin/logo1_1.jpg": 5354,
	"./pushpin/logo2_1.png": 4705,
	"./pushpin/logo2_2.png": 5722,
	"./pushpin/logo2_3.png": 4579,
	"./pushpin/mockup1.png": 7062,
	"./pushpin/mockup2.png": 4477,
	"./pushpin/outcome1.png": 6295,
	"./pushpin/outcome2.png": 3644,
	"./pushpin/prototype1_1.png": 9969,
	"./pushpin/prototype1_2.png": 986,
	"./pushpin/prototype1_3.png": 9843,
	"./pushpin/prototype2_1.png": 4942,
	"./pushpin/prototype2_2.png": 2293,
	"./pushpin/wireframe1.jpg": 2025,
	"./pushpin/wireframe2.jpg": 5886,
	"./pushpin_cover.png": 8265,
	"./zoom_cover.png": 9531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9462;